import { useNavigate } from "react-router-dom";
import { UserListConponents } from "../../style/contents/backup/backup";
import { BackupUser } from "../../view/contents/backup/backup.user";
import { fetchLoadClientLogin, LoginProps } from "../../api/auth";

interface Props {
  data: BackupUser[];
  isLoading?: boolean; // ✅ 추가
  devicePathPrefix?: string;
}

const UserList = ({
  data,
  isLoading,
  devicePathPrefix = "/backup/device",
}: Props) => {
  const navigate = useNavigate();

  const userClicked = async (
    userId: number,
    userAccount: string,
    password: string,
    department: string
  ) => {
    const companyCode = localStorage.getItem("companyCode");

    const requestData: LoginProps = {
      companyCode: companyCode || "",
      userAccount: userAccount,
      password: password,
      deviceId: "", // ✅ 사용자용 deviceId 필수 (빈 문자열)
    };

    try {
      await fetchLoadClientLogin(requestData);

      // ✅ department 값을 Base64로 인코딩해서 URL에 포함
      const encodedDept = btoa(encodeURIComponent(department || ""));

      navigate(`${devicePathPrefix}/${userId}?department=${encodedDept}`);
    } catch (err) {
      console.log(err);
    }
  };

  if (isLoading) {
    return <div className="loading">데이터를 불러오는 중입니다...</div>;
  }

  if (!data || data.length === 0) {
    return <div className="no-data">🔍 검색 결과가 없습니다.</div>;
  }

  return (
    <UserListConponents>
      {data.map((item) => (
        <div
          key={item.userId}
          className="list-item"
          onClick={() =>
            userClicked(
              item.userId,
              item.userAccount,
              item.password,
              item.department
            )
          }
        >
          <span className="user-account">
            {item.userName ? `${item.userName}` : "미입력"}
          </span>
          <span className="user-name">
            ( {item.department ? item.department : "-"} |{" "}
            {item.userAccount ? ` ${item.userAccount} ` : " - "} )
          </span>
        </div>
      ))}
    </UserListConponents>
  );
};

export default UserList;
